function Movie({movie}) {
    return(
        <div className='movie__container'>
            <h2>{movie.title}</h2>
            <img src={'https://image.tmdb.org/t/p/w500' + movie.poster_path} alt={movie.title} />
        </div>
    )
}

export default Movie;